module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (69).a9a7380c.jpg";